import React from "react";

var Laptop = function Laptop(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5.182 13.522h13.636m-13.636 0l-1.91 4.793a.5.5 0 00.465.685h16.526a.5.5 0 00.464-.685l-1.909-4.793m-13.636 0V5.5a.5.5 0 01.5-.5h12.636a.5.5 0 01.5.5v8.022",
    stroke: "currentColor",
    strokeWidth: "2"
  }));
};

Laptop.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export { Laptop };